import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Nashiktopunecabservice() {



const cardData = {
  keyword: " Nashik to Pune Cab Service ",

"headingDescription": "SRS Cab Service offers Nashik to Pune Cab Service, providing a safe, comfortable, and reliable travel solution for business travelers, corporate clients, and tourists. Our well-maintained vehicles, professional drivers, and punctual pickups ensure a smooth journey from Nashik to Pune. Ideal for airport transfers, corporate trips, and personal travel, SRS Cab Service delivers flexible booking options, transparent pricing, and 24/7 customer support for a stress-free and enjoyable ride.",
"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada is a historic fortification in Pune known for its rich Maratha heritage. Travelers using SRS Cab Service often visit this iconic landmark to explore its architecture and history."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Aga Khan Palace is a significant historical site associated with India’s freedom movement. Visitors using SRS Cab Service often explore its beautiful gardens and museum."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Sinhagad Fort is a popular trekking destination offering panoramic views of the surrounding hills. Travelers using SRS Cab Service often visit for adventure and scenic beauty."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "Dagdusheth Halwai Ganpati Temple is one of Pune’s most revered temples dedicated to Lord Ganesha. Visitors using SRS Cab Service often come here for spiritual blessings."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Raja Dinkar Kelkar Museum showcases a vast collection of artifacts representing Indian culture and heritage. Travelers using SRS Cab Service often visit to experience traditional art and history."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Pataleshwar Cave Temple is an ancient rock-cut temple dedicated to Lord Shiva. Visitors using SRS Cab Service often admire its unique architecture and peaceful atmosphere."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam is a serene getaway known for its scenic surroundings and relaxing environment. Travelers using SRS Cab Service often enjoy picnics and sunset views here."
  },
  {
    "title": "Pune Okayama Friendship Garden",
    "description": "Pune Okayama Friendship Garden is a beautifully landscaped garden inspired by Japanese design. Visitors using SRS Cab Service often enjoy its calm and refreshing ambiance."
  },
  {
    "title": "Vetal Tekdi",
    "description": "Vetal Tekdi is a popular spot for hiking and nature walks, offering panoramic views of Pune city. Travelers using SRS Cab Service often visit for outdoor activities and fresh air."
  },
  {
    "title": "Phoenix Marketcity Pune",
    "description": "Phoenix Marketcity Pune is a modern shopping and entertainment hub. Visitors using SRS Cab Service often explore it for shopping, dining, and leisure activities."
  }
],



"services": [
    {
      "name": "Nashik to Pune Cab Service",
      "description": "Nashik to Pune cab service offers reliable and comfortable intercity travel for passengers. Customers can book cabs for business trips, family travel, or personal journeys. Professional drivers ensure safe highway driving. Well-maintained vehicles enhance travel comfort. Flexible booking options are available. Travel easily with trusted cab services."
    },
    {
      "name": "Nashik to Pune Taxi Service",
      "description": "Nashik to Pune taxi service provides convenient transportation for long-distance travel. Customers can book taxis for smooth and hassle-free journeys. Experienced drivers ensure safe travel. Comfortable seating enhances the experience. Flexible booking options are available. Travel easily with taxi services."
    },
    {
      "name": "Nashik to Pune Cab Booking",
      "description": "Nashik to Pune cab booking allows customers to reserve rides quickly and easily. Users can book cabs online or via call for instant travel needs. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with cab booking services."
    },
    {
      "name": "Nashik to Pune Taxi Fare",
      "description": "Nashik to Pune taxi fare offers transparent and affordable pricing for customers. Users can plan travel with clear cost estimates. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. No hidden charges ensure trust. Travel easily with budget-friendly taxi services."
    },
    {
      "name": "One Way Cab Nashik to Pune",
      "description": "One way cab Nashik to Pune offers cost-effective travel without return charges. Customers can book direct drop services easily. Professional drivers ensure safe highway journeys. Comfortable vehicles enhance experience. Transparent pricing ensures affordability. Travel easily with one way cab services."
    },
    {
      "name": "Round Trip Cab Nashik to Pune",
      "description": "Round trip cab Nashik to Pune provides flexible travel for return journeys. Customers can book cabs for multiple-day trips. Professional drivers ensure safe travel. Comfortable vehicles enhance long-distance experience. Flexible booking options are available. Travel easily with round trip cab services."
    },
    {
      "name": "Nashik to Pune Car Rental",
      "description": "Nashik to Pune car rental offers reliable vehicle options for intercity travel. Customers can choose from sedans, SUVs, and premium cars. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible rental options are available. Travel easily with car rental services."
    },
    {
      "name": "Nashik to Pune Innova Cab",
      "description": "Nashik to Pune Innova cab provides spacious and comfortable SUV travel. Customers can enjoy extra legroom and luggage space. Professional drivers ensure safe journeys. Ideal for family and group travel. Transparent pricing ensures value. Travel easily with Innova cab services."
    },
    {
      "name": "Nashik to Pune Innova Crysta Cab",
      "description": "Nashik to Pune Innova Crysta cab offers premium SUV travel with luxury comfort. Customers can enjoy plush seating and smooth rides. Professional drivers ensure safe journeys. Ideal for corporate and family travel. Transparent pricing ensures value. Travel easily with Innova Crysta services."
    },
    {
      "name": "Nashik to Pune Ertiga Cab",
      "description": "Nashik to Pune Ertiga cab offers comfortable 7 seater travel for small groups. Customers can enjoy spacious seating and smooth journeys. Professional drivers ensure safe travel. Ideal for family trips. Transparent pricing ensures affordability. Travel easily with Ertiga cab services."
    },
    {
      "name": "Nashik to Pune Dzire Cab",
      "description": "Nashik to Pune Dzire cab provides economical sedan travel for passengers. Customers can book budget-friendly rides for intercity travel. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Transparent pricing ensures affordability. Travel easily with Dzire cab services."
    },
    {
      "name": "Nashik to Pune Sedan Cab",
      "description": "Nashik to Pune sedan cab offers comfortable and affordable travel for individuals and small families. Customers can enjoy smooth rides and ample space. Professional drivers ensure safe journeys. Fuel-efficient vehicles reduce costs. Flexible booking options are available. Travel easily with sedan cab services."
    },
    {
      "name": "Nashik to Pune SUV Cab",
      "description": "Nashik to Pune SUV cab provides spacious and powerful vehicles for long-distance travel. Customers can enjoy extra comfort and luggage capacity. Professional drivers ensure safe journeys. Ideal for group travel. Flexible booking options are available. Travel easily with SUV cab services."
    },
    {
      "name": "Nashik to Pune Luxury Cab",
      "description": "Nashik to Pune luxury cab offers premium travel experience with high-end vehicles. Customers can enjoy superior comfort and style. Professional drivers ensure safe journeys. Ideal for corporate and VIP travel. Luxury interiors enhance experience. Travel easily with luxury cab services."
    },
    {
      "name": "Nashik to Pune Tempo Traveller",
      "description": "Nashik to Pune tempo traveller provides comfortable group travel for larger passengers. Customers can book vehicles for tours, events, and family trips. Professional drivers ensure safe journeys. Spacious seating enhances comfort. Flexible booking options are available. Travel easily with tempo traveller services."
    },
    {
      "name": "Nashik to Pune Urbania Cab",
      "description": "Nashik to Pune Urbania cab offers premium group travel with modern design vehicles. Customers can enjoy high-roof spacious seating. Professional drivers ensure safe journeys. Ideal for corporate and family groups. Comfortable interiors enhance experience. Travel easily with Urbania cab services."
    },
    {
      "name": "Cheap Cab Nashik to Pune",
      "description": "Cheap cab Nashik to Pune offers budget-friendly travel options for customers. Users can book affordable rides without compromising comfort. Professional drivers ensure safe journeys. Well-maintained vehicles enhance experience. Transparent pricing ensures trust. Travel easily with economical cab services."
    },
    {
      "name": "Best Taxi Nashik to Pune",
      "description": "Best taxi Nashik to Pune provides top-rated travel experience for customers. Users can enjoy reliable and comfortable journeys. Professional drivers ensure safe travel. Premium vehicles enhance experience. Flexible booking options are available. Travel easily with best taxi services."
    }
  ],
  "tableData": [
    ["Nashik to Pune Cab Service","Nashik to Pune Taxi Service"],
    ["Nashik to Pune Cab Booking","Nashik to Pune Taxi Fare"],
    ["One Way Cab Nashik to Pune","Round Trip Cab Nashik to Pune"],
    ["Nashik to Pune Car Rental","Nashik to Pune Innova Cab"],
    ["Nashik to Pune Innova Crysta Cab","Nashik to Pune Ertiga Cab"],
    ["Nashik to Pune Dzire Cab","Nashik to Pune Sedan Cab"],
    ["Nashik to Pune SUV Cab","Nashik to Pune Luxury Cab"],
    ["Nashik to Pune Tempo Traveller","Nashik to Pune Urbania Cab"],
    ["Cheap Cab Nashik to Pune","Best Taxi Nashik to Pune"]
  ],



whychoose: [
  {
    WhyChooseheading: "Reliable Nashik to Pune Cab Service",
    WhyChoosedescription: "SRS Cab Service offers dependable Nashik to Pune cab service for safe and comfortable intercity travel. Customers can enjoy smooth rides with professional drivers and well-maintained vehicles."
  },
  {
    WhyChooseheading: "Affordable Nashik to Pune Cab Pricing",
    WhyChoosedescription: "We provide budget-friendly cab services from Nashik to Pune with transparent pricing. Customers receive complete fare details including tolls and driver charges with no hidden costs."
  },
  {
    WhyChooseheading: "Experienced Highway Drivers",
    WhyChoosedescription: "Our drivers are experienced in long-distance highway routes, ensuring safe, smooth, and stress-free travel between Nashik and Pune."
  },
  {
    WhyChooseheading: "24/7 Cab Service Availability",
    WhyChoosedescription: "SRS Cab Service operates 24/7 for Nashik to Pune cab bookings, making it ideal for business travel, family trips, and emergency journeys."
  },
  {
    WhyChooseheading: "Comfortable & AC Vehicles",
    WhyChoosedescription: "We provide clean, well-maintained, and air-conditioned vehicles for a relaxing and comfortable journey."
  },
  {
    WhyChooseheading: "Flexible One Way & Round Trip Options",
    WhyChoosedescription: "Customers can choose from one-way cab service, round-trip bookings, and same-day return options based on their travel needs."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "We offer hatchbacks, sedans, SUVs like Ertiga and Innova, premium Innova Crysta, and Tempo Travellers for individuals and group travel."
  },
  {
    WhyChooseheading: "Trusted Nashik to Pune Cab Booking",
    WhyChoosedescription: "SRS Cab Service is trusted for Nashik to Pune cab bookings due to punctual service, professional drivers, and reliable travel experience."
  }
]
}

const faqData = [
  { question: "Do you provide Nashik to Pune cab service?", answer: "Yes, SRS Cab Service offers reliable cab services from Nashik to Pune for all travel needs." },
  { question: "What is the distance between Nashik and Pune?", answer: "The distance is approximately 210–220 km and takes around 4 to 5 hours depending on traffic and route." },
  { question: "What is the starting cab fare?", answer: "Cab fares typically start from ₹3000–₹5500 depending on vehicle type and travel timing." },
  { question: "Is one-way cab available?", answer: "Yes, one-way cab services are available and are more affordable compared to round-trip bookings." },
  { question: "Is cab service available 24 hours?", answer: "Yes, our Nashik to Pune cab service operates 24/7." },
  { question: "Which vehicles are available?", answer: "We offer hatchbacks, sedans, SUVs, Innova Crysta, and Tempo Travellers." },
  { question: "Can I book cab online?", answer: "Yes, you can easily book your Nashik to Pune cab service online or via phone." },
  { question: "Do you provide doorstep pickup?", answer: "Yes, we provide pickup from home, office, or any location in Nashik." },
  { question: "Are vehicles cleaned regularly?", answer: "Yes, all vehicles are properly cleaned and sanitized before every trip." },
  { question: "Do you provide Pune city drop?", answer: "Yes, we provide drop service anywhere in Pune including Hinjewadi, Wakad, Baner, and Kharadi." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Nitin Joshi",
    feedback:
      "Booked Nashik to Pune cab with SRS Cab Service. Very smooth journey and on-time pickup.",
    rating: 5
  },
  {
    id: 2,
    name: "Ms. Pooja Kale",
    feedback:
      "Great service from Nashik to Pune. Clean car, polite driver, and affordable pricing.",
    rating: 5
  }
];






















const Images = [
{ place: "/images/keyword/1.jpg", text: "Pune Cab Service", link: "Pune-Cab-Service" },
{ place: "/images/keyword/2.jpg", text: "Pune Taxi Hire", link: "Pune-Taxi-Hire" },
{ place: "/images/keyword/3.jpg", text: "Pune Online Cabs Booking", link: "Pune-Online-Cabs-Booking" },
{ place: "/images/keyword/4.jpg", text: "Best Cabs Service in Pune", link: "Best-Cabs-Service-in-Pune" },
{ place: "/images/keyword/5.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
{ place: "/images/keyword/6.jpg", text: "Pune to Nasik Cabs", link: "Pune-to-Nasik-Cabs" },
{ place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cab", link: "Pune-to-Mahabaleshwar-Cab" },
{ place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cab", link: "Pune-to-Lonavala-Cab" },
{ place: "/images/keyword/9.jpg", text: "Pune to Trimbakeshwar Cab", link: "Pune-to-Trimbakeshwar-Cab" },
{ place: "/images/keyword/10.jpg", text: "Pune to Shirdi Cab", link: "Pune-to-Shirdi-Cab" },
{ place: "/images/keyword/11.jpg", text: "Pune to Bhimashankar Cab", link: "Pune-to-Bhimashankar-Cab" },
{ place: "/images/keyword/12.jpg", text: "Pune to Indore Cabs", link: "Pune-to-Indore-Cabs" },
{ place: "/images/keyword/13.jpg", text: "Pune to Konkan Darshan Cab", link: "Pune-to-Konkan-Darshan-Cab" },
{ place: "/images/keyword/14.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
{ place: "/images/keyword/15.jpg", text: "Pune Outstation Cabs", link: "Pune-Outstation-Cabs" },
{ place: "/images/keyword/16.jpg", text: "Pune to Panchgani Cab", link: "Pune-to-Panchgani-Cab" },
{ place: "/images/keyword/17.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
{ place: "/images/keyword/18.jpg", text: "Ashtavinayak Darshan Cab", link: "Ashtavinayak-Darshan-Cab" },
{ place: "/images/keyword/19.jpg", text: "Pune to Nagpur Cab", link: "Pune-to-Nagpur-Cab" },
{ place: "/images/keyword/20.jpg", text: "Pune to Goa Cab", link: "Pune-to-Goa-Cab" },
{ place: "/images/keyword/21.jpg", text: "Pune to Ajanta Ellora Cab", link: "Pune-to-Ajanta-Ellora-Cab" },
{ place: "/images/keyword/22.jpg", text: "Pune to Satara Cabs", link: "Pune-to-Satara-Cabs" },
{ place: "/images/keyword/23.jpg", text: "Pune Airport Cabs", link: "Pune-Airport-Cabs" },
{ place: "/images/keyword/24.jpg", text: "Pune to Ayodhya Tour Package", link: "Pune-to-Ayodhya-Tour-Package" },
{ place: "/images/keyword/25.jpg", text: "Corporate Cab Service in Pune", link: "Corporate-Cab-Service-in-Pune" },
];














const jsonData = {
  "@context": "https://schema.org",
  "@type": "TaxiService",
  "name": "Nashik to Pune Cab Service | SRS Cab Service",
  "description": "Book reliable Nashik to Pune cab service with SRS Cab Service. One-way and round trip taxis available with Innova Crysta, Ertiga, Dzire, SUV, sedan, luxury cars, tempo traveller, and Urbania for comfortable travel at best fares.",
  "image": "https://www.srscabservice.com/logo.png",
  "telephone": "+91 9011955415",
  "address": {
    "@type": "PostalAddress",
    "streetAddress": "Nashik",
    "addressLocality": "Nashik",
    "addressRegion": "Maharashtra",
    "postalCode": "",
    "addressCountry": "IN"
  },
  "geo": {
    "@type": "GeoCoordinates",
    "latitude": "19.9975",
    "longitude": "73.7898"
  },
  "url": "https://www.srscabservice.com/nashik-to-pune-cab",
  "areaServed": ["Nashik", "Pune", "Maharashtra"],
  "openingHours": "Mo-Su 00:00-23:59",
  "priceRange": "₹₹",
  "serviceType": [
    "Nashik to Pune Cab Service",
    "One Way Cab Nashik to Pune",
    "Round Trip Cab Nashik to Pune",
    "Nashik to Pune Taxi Service",
    "Nashik to Pune Car Rental",
    "SUV, Sedan, Innova Crysta, Ertiga, Luxury Cab, Tempo Traveller, Urbania"
  ],
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "bestRating": "5",
    "worstRating": "1",
    "ratingCount": "710"
  }
};



  return (
    <div>


<Helmet>
  <title>Nashik to Pune Cab Service | SRS Cab Service</title>
  <meta
    name="description"
    content="Book Nashik to Pune cab service with SRS Cab Service. One way and round trip taxis available with Innova, Ertiga, Dzire, SUV, sedan, luxury cabs, tempo traveller and Urbania at best fares."
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>




 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/115.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#030706', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Srs Cab Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2 d-flex">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
               <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Srs Cab Service</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Srs Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                        //   title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919011955415" className="pc-call">+91 9011955415</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919011955415"
          target="_blank"
          rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp"></i> WhatsApp
        </a>
        <a href="tel:+919011955415" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@srscabservice.com" className="pc-email">
        booking@srscabservice.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-geo-alt-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Srs Cab Service</strong><br />
        Office no. 3 Mankar corner, kaspate chowk wakad Pune 411027
      </address>
    </section>
  </div>
</div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Nashiktopunecabservice;